module.exports = __webpack_public_path__ + "img/image3.8b2fbae.webp";